/* eslint-disable @typescript-eslint/naming-convention */
import { Capacitor } from '@capacitor/core';
import { getEnv } from 'common/utils/env';

const isNativeApp = Capacitor.isNativePlatform();
// Native hardcodes the API host rather than reading env at all - that is what
// kept the app working while runtimeEnv() was returning nothing on device.
// Left exactly as it was; getEnv only replaces the web read.
export const apiRootUrl = `${isNativeApp ? 'https://api.doqit.io/' : getEnv('REACT_APP_API_URL')}api/v1`;
export const mixpanelToken = getEnv('REACT_APP_MIXPANEL_TOKEN');
// RTK Query

export const signInUrl = '/signin';
export const signUpUrl = '/sign-up';
export const verifyUrl = '/verify-mail-otp';
export const resendVerificationOtp = '/resend-verification-mail/%userId%';
export const resetPasswordLink = '/forgot-password';
export const resetPassword = '/reset-password';
export const validateToken = '/validate-token';
export const categoryUrl = '/categories';
export const hideCategoryUrl = '/category-visibility/hide';
export const showCategoryUrl = '/category-visibility/show';
export const searchDocumentUrl = '/document/search/%searchQuery%';
export const preSignedUrl = '/generate-presigned-post-url';
export const documents = '/documents';
export const uncategorizedDocuments = '/documents/uncategorized';
export const viewCategoryDocuments = '/category/%categoryId%/documents';
export const deleteS3File = '/delete-s3-file';
export const deleteS3FileById = '/document-file/%docFileId%';
export const vehicleDvla = '/vehicles';
export const pinDocuments = '/document/%documentId%/pin';
export const dashboardCategories = '/categories';
export const dashboardCategoriesCount = '/categories-docs-count';
export const deleteDocument = 'document/%documentId%/delete';
// Multi-select bulk actions (1-100 document ids per request).
export const batchDeleteDocuments = '/documents/batch-delete';
export const batchCategoryDocuments = '/documents/batch-category';
export const editDocumentDetails = 'document/%documentId%/details';
export const updateDocument = 'document/%documentId%/update';
export const applyDocumentScan = 'document/%documentId%/apply-scan';
export const deleteScanCopy = '/document/scan-copy';
export const upcomingReminders = '/reminders/time';
// Flat, unbucketed reminders - UserController::reminders. Unlike
// upcomingReminders above, this has no fixed-window bucketing, so it never
// drops renewals more than 730 days out. Used by the Timeline tab.
export const timelineReminders = '/reminders';
export const doneReminders = '/reminders/done';
export const deleteReminder = '/reminders/%reminderId%';
export const markAsDoneReminders = '/reminders/%reminderId%/done';
export const remindLaterReminders = '/reminders/%reminderId%/later';
export const homeReminders = '/reminders/home';
export const logout = '/logout';
export const deviceTokens = '/device-tokens';
export const pushOpened = '/push-notifications/%id%/opened';
export const updateUserProfile = '/user/%userId%/update';
export const faq = '/faqs';
export const deleteUser = '/user';
export const vehicleList = '/vehicles';
export const deleteVehicle = '/vehicles/%id%';
export const verifyMfaOtp = '/verify-mfa-otp';
export const verifyLockPassword = '/verify-lock-password';
export const cancelSubscription = '/subscriptions/cancel';
export const customCategories = '/custom-categories';
export const smartScan = '/document/scan';
export const vehicleManual = '/vehicles/manual';
export const quickAccessUrl = '/documents/quick-access';
// Flag-ON (REACT_APP_DASHBOARD_AGGREGATE) replacement for the dashboard's
// per-category badge fan-out: one call returns has_reminders/has_shares per
// category. See DashboardService.ts's categorySignalsAction.
export const categorySignalsUrl = '/documents/category-signals';
export const documentNameIndexUrl = '/documents/name-index';

// Connections (Document Sharing)
export const searchUsers = '/users/search';
export const connections = '/connections';
export const pendingConnections = '/connections/pending';
export const sentConnections = '/connections/sent';
export const acceptConnection = '/connections/%id%/accept';
export const rejectConnection = '/connections/%id%/reject';
export const connectionShareAll = '/connections/%id%/share-all';

// Invitations (for non-Doqit users)
export const invitations = '/invitations';
export const resendInvitation = '/invitations/%id%/resend';
export const deleteInvitation = '/invitations/%id%';

// Document Sharing
export const shareDocument = '/document/%id%/share';
export const documentShares = '/document/%id%/shares';
export const documentShare = '/document-share/%id%';

// Shared With Me
export const sharedWithMe = '/shared-with-me';
export const sharedDocument = '/shared-document/%shareId%';
export const sharedDocumentByDoc = '/shared-document/by-document/%documentId%';

// Profile Picture
export const profilePicture = '/user/profile-picture';

// Properties
export const properties = '/properties';
export const propertyById = '/properties/%id%';

// Vehicle Sharing
export const shareVehicle = '/vehicles/%id%/share';
export const vehicleShares = '/vehicles/%id%/shares';
export const vehicleShare = '/vehicle-share/%id%';

// Property Sharing
export const shareProperty = '/properties/%id%/share';
export const propertyShares = '/properties/%id%/shares';
export const propertyShare = '/property-share/%id%';

// Public Link Sharing
export const createPublicLink = '/document/%id%/public-link';
export const getPublicLinks = '/document/%id%/public-links';
export const getAllUserPublicLinks = '/public-links';
export const publicLink = '/public-link/%id%';
export const publicLinkViews = '/public-link/%id%/views';
